const options = [
  "Very satisfied",
  "Somewhat satisfied",
  "Dissatisfied",
  "Very dissatisfied",
  "N/A",
];

export const FeedbackQuestions = [
  {
    id: "aq1",
    label: "Were you able to subscribe and sign in/out without any issues?",
    options: ["Yes", "No"],
  },
  {
    id: "aq2",
    label:
      "Did the platform offer an easy experience when deploying serverless functions?",
    options: options,
  },

  {
    id: "aq3",
    label: "Did you find this tool helpful for your programming needs?",
    options: options,
  },

  {
    id: "aq4",
    label:
      "Rawdat.AI provides a good range of programming languages and meets my work/study needs.",
    options: options,
  },

  {
    id: "aq5",
    label:
      "How satisfied are you with the OVERALL quality of Rawdat.AI serverless platform?",
    options: options,
  },

  {
    id: "aq6",
    label:
      "I would recommend to others to utilize Rawdat.AI for their programming/coding deployment",
    options: options,
  },

  {
    id: "aq7",
    label:
      "Rawdat.AI will support more programming languages in future releases. Would you consider a monthly membership with us?",
    options: ["Yes", "No"],
  },

  {
    id: "aq8",
    label:
      "Rawdat.AI speeds up the deployment of functions, helping me complete my programming tasks faster.",
    options: options,
  },
];
